import { MoreOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import { LabelValuePairsType } from 'core/types/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  placeholder?: string;
  onPressEnter?: (e: string, data: string) => void;
  defaultValue?: string;
  defaultValueSelectSearch?: string;
  dataFieldSearch?: LabelValuePairsType;
  handleSelectChange?: (value: string) => void;
  handleSelectClear?: () => void;
  valueFieldSearch?: string;
}

export default function SearchInput({
  placeholder,
  onPressEnter,
  defaultValue,
  defaultValueSelectSearch,
  dataFieldSearch,
}: SearchInputProps) {
  const { t } = useTranslation();

  const showFieldSearch = dataFieldSearch && dataFieldSearch?.length > 0;
  const [value, setValue] = useState(defaultValue);
  const [valueFieldSearch, setValueFieldSearch] = useState(
    defaultValueSelectSearch,
  );
  const onChange = (e) => setValue(e.target.value);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setValueFieldSearch(defaultValueSelectSearch);
  }, [defaultValueSelectSearch]);

  return (
    <div className="relative">
      {showFieldSearch && (
        <div className="absolute -translate-y-2/4 top-2/4 left-1 z-[2]">
          <Select
            defaultValue={defaultValueSelectSearch}
            value={valueFieldSearch}
            className="w-[150px]"
            onChange={(v) => setValueFieldSearch(v)}
            onClear={() => setValueFieldSearch(undefined)}
            options={dataFieldSearch}
            allowClear
            placeholder={t('common.button.select')}
          />
        </div>
      )}
      <Input
        size="large"
        className={`search-input text-sm ${showFieldSearch && 'pl-[160px]'}`}
        placeholder={placeholder}
        prefix={!showFieldSearch && <SearchOutlined />}
        onPressEnter={(e) =>
          onPressEnter(e.currentTarget.value, valueFieldSearch)
        }
        defaultValue={defaultValue}
        value={value}
        suffix={<MoreOutlined className="pointer" />}
        onChange={onChange}
      />
    </div>
  );
}
